export type TChannelCountMode = 'clamped-max' | 'explicit' | 'max';
